<template>
  <div :style="{'display': installBtn}" id="wrapperInstall">
    <div class="button" @click="installer()" >Установить на рабочий стол</div>
  </div>
</template>

<script>
  export default {
    name: "installPromts",
    data(){
      return {
        installBtn: 'none',
        installer: undefined
      };
    },
    created(){
      try {
        //кнопка установки в хроме и на андройде
        let installPromt;
        window.addEventListener('beforeinstallprompt', e => {
          e.preventDefault();
          installPromt = e;
          this.installBtn = 'block';
        });
        this.installer = () => {
          this.installBtn = 'none';
          installPromt.prompt();
          installPromt.userChoice.then(result => {
            if (result.outcome === 'accepted') {
              console.log('User accepted');
            } else {
              console.log('User denied');
            }
            installPromt = null;
          });
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
</script>

<style scoped>
  #wrapperInstall{
    position: fixed;
    bottom:0;
    right:0;
  }
</style>
